module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_vm._v("\n    Indstillinger\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a7ca842"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/settings.vue
// module id = 287
// module chunks = 1